import { useEffect, useState } from "react"
import Loader from "./loader"

export const ToggleWithLocalisedLoading = ({ id, checked, onChange, loadingStateTracker }) => {
    const [isLoading, setIsLoading] = useState(false)
    const handleChange = (isChecked) => {
        setIsLoading(true)
        onChange(isChecked)
    }

    useEffect(() => setIsLoading(false), [loadingStateTracker])

    return (
        <span className='custom-control custom-switch'>
            {
                isLoading
                    ? <span className="custom-control-label custom-toggle toggle-loading ml-3"><Loader classAddOn="inline-loader" /></span>
                    : <>
                        <input className="custom-control-input" type="checkbox" id={ id } checked={ checked } onChange={ (e) => handleChange(e.target.checked) } />
                        <label className="custom-control-label custom-toggle ml-3" htmlFor={ id }></label>
                    </>
            }
        </span>


    )
}